import { logger } from "../../app/utils/Debug";

export function loginUrl() {
  var url = "/users/loginUser";
  return url;
}

export function transactionListUrl({ filterValues, queryParams }) {
  const {
    deposite_type,
    status,
    sc_type,
    searchAmounts,
    searchConfirmationId,
    searchSCTransactionId,
    searchIPCountry,
    searchReceiverName,
    searchSenderName,
    searchTransactionId,
    searchAccountNumber
  } = filterValues;

  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;

  let skip = (pageNumber - 1) * pageSize;
  var url = `/transactions/getTransactionHistory?limit=${pageSize}&offset=${skip}`;

  if (deposite_type) {
    url = url.concat(`&transactionModeId=${deposite_type}`);
  }

  if (status) {
    url = url.concat(`&transactionStatusId=${status}`);
  }

  if (sc_type) {
    url = url.concat(`&sc_type=${sc_type}`);
  }

  if (searchAmounts) {
    url = url.concat(`&amount=${searchAmounts}`);
  }

  if (searchConfirmationId) {
    url = url.concat(`&confirmation_id=${searchConfirmationId}`);
  }

  if (searchSCTransactionId) {
    url = url.concat(`&sc_transactionId=${searchSCTransactionId}`);
  }

  if (searchIPCountry) {
    url = url.concat(`&ip_country=${searchIPCountry}`);
  }

  if (searchReceiverName) {
    url = url.concat(`&receiver_name=${searchReceiverName}`);
  }

  if (searchSenderName) {
    url = url.concat(`&sender_name=${searchSenderName}`);
  }

  if (searchTransactionId) {
    url = url.concat(`&id=${searchTransactionId}`);
  }

  if (searchAccountNumber) {
    url = url.concat(`&account_number=${searchAccountNumber}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function transactionsReportUrl({ queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
  const skip = (pageNumber - 1) * pageSize;
  let url = `/reports/getFullReport?limit=${pageSize}&offset=${skip}`;

  const {
    amount,
    confirmationDate,
    confirmationId,
    receiverEmail,
    receiverFirstName,
    receiverId,
    receiverLastName,
    receiverMobile,
    scAddress,
    scTransactionId,
    scTransactionType,
    senderEmail,
    senderFirstName,
    senderId,
    senderLastName,
    senderMobile,
    totalAmount,
    transactionDate,
    transactionFees,
    transactionId,
    transactionMode,
    transactionStatus,
    transactionType,
    dateFrom,
    dateTo
  } = filter || {};

  if (amount) {
    url = url.concat(`&amount=${amount}`);
  }

  if (confirmationDate) {
    url = url.concat(`&confirmation_date=${confirmationDate}`);
  }

  if (confirmationId) {
    url = url.concat(`&confirmation_id=${confirmationId}`);
  }

  if (receiverEmail) {
    url = url.concat(`&receiverEmail=${receiverEmail}`);
  }

  if (receiverFirstName) {
    url = url.concat(`&receiverFirstName=${receiverFirstName}`);
  }

  if (receiverId) {
    url = url.concat(`&receiverId=${receiverId}`);
  }

  if (receiverLastName) {
    url = url.concat(`&receiverLastName=${receiverLastName}`);
  }

  if (receiverMobile) {
    url = url.concat(`&receiverCellNumber=${receiverMobile}`);
  }

  if (scAddress) {
    url = url.concat(`&scAddress=${scAddress}`);
  }

  if (scTransactionId) {
    url = url.concat(`&scTransactionId=${scTransactionId}`);
  }

  if (scTransactionType) {
    url = url.concat(`&scType=${scTransactionType}`);
  }

  if (senderEmail) {
    url = url.concat(`&senderEmail=${senderEmail}`);
  }

  if (senderFirstName) {
    url = url.concat(`&senderFirstName=${senderFirstName}`);
  }

  if (senderId) {
    url = url.concat(`&senderId=${senderId}`);
  }

  if (senderLastName) {
    url = url.concat(`&senderLastName=${senderLastName}`);
  }

  if (senderMobile) {
    url = url.concat(`&senderCellNumber=${senderMobile}`);
  }

  if (totalAmount) {
    url = url.concat(`&totalAmount=${totalAmount}`);
  }

  if (transactionDate) {
    url = url.concat(`&dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  if (transactionFees) {
    url = url.concat(`&fees=${transactionFees}`);
  }

  if (transactionId) {
    url = url.concat(`&transactionId=${transactionId}`);
  }

  if (transactionMode) {
    url = url.concat(`&transactionModeId=${transactionMode}`);
  }

  if (transactionStatus) {
    url = url.concat(`&transactionStatusId=${transactionStatus}`);
  }

  if (transactionType) {
    url = url.concat(`&transactionType=${transactionType}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function transactionsReportExportUrl({ queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
  const skip = (pageNumber - 1) * pageSize;
  let url = `/reports/exportTransactions?limit=${pageSize}&offset=${skip}`;

  const {
    amount,
    confirmationDate,
    confirmationId,
    receiverEmail,
    receiverFirstName,
    receiverId,
    receiverLastName,
    receiverMobile,
    scAddress,
    scTransactionId,
    scTransactionType,
    senderEmail,
    senderFirstName,
    senderId,
    senderLastName,
    senderMobile,
    totalAmount,
    transactionDate,
    transactionFees,
    transactionId,
    transactionMode,
    transactionStatus,
    transactionType,
    dateFrom,
    dateTo
  } = filter || {};

  if (amount) {
    url = url.concat(`&amount=${amount}`);
  }

  if (confirmationDate) {
    url = url.concat(`&confirmation_date=${confirmationDate}`);
  }

  if (confirmationId) {
    url = url.concat(`&confirmation_id=${confirmationId}`);
  }

  if (receiverEmail) {
    url = url.concat(`&receiverEmail=${receiverEmail}`);
  }

  if (receiverFirstName) {
    url = url.concat(`&receiverFirstName=${receiverFirstName}`);
  }

  if (receiverId) {
    url = url.concat(`&receiverId=${receiverId}`);
  }

  if (receiverLastName) {
    url = url.concat(`&receiverLastName=${receiverLastName}`);
  }

  if (receiverMobile) {
    url = url.concat(`&receiverCellNumber=${receiverMobile}`);
  }

  if (scAddress) {
    url = url.concat(`&scAddress=${scAddress}`);
  }

  if (scTransactionId) {
    url = url.concat(`&scTransactionId=${scTransactionId}`);
  }

  if (scTransactionType) {
    url = url.concat(`&scType=${scTransactionType}`);
  }

  if (senderEmail) {
    url = url.concat(`&senderEmail=${senderEmail}`);
  }

  if (senderFirstName) {
    url = url.concat(`&senderFirstName=${senderFirstName}`);
  }

  if (senderId) {
    url = url.concat(`&senderId=${senderId}`);
  }

  if (senderLastName) {
    url = url.concat(`&senderLastName=${senderLastName}`);
  }

  if (senderMobile) {
    url = url.concat(`&senderCellNumber=${senderMobile}`);
  }

  if (totalAmount) {
    url = url.concat(`&totalAmount=${totalAmount}`);
  }

  if (transactionDate) {
    url = url.concat(`&dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  if (transactionFees) {
    url = url.concat(`&fees=${transactionFees}`);
  }

  if (transactionId) {
    url = url.concat(`&transactionId=${transactionId}`);
  }

  if (transactionMode) {
    url = url.concat(`&transactionModeId=${transactionMode}`);
  }

  if (transactionStatus) {
    url = url.concat(`&transactionStatusId=${transactionStatus}`);
  }

  if (transactionType) {
    url = url.concat(`&transactionType=${transactionType}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function clearingAccountReportUrl({ queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
  const skip = (pageNumber - 1) * pageSize;
  let url = `/reports/getUnityReport?limit=${pageSize}&offset=${skip}`;

  const {
    amount,
    confirmationDate,
    confirmationId,
    receiverEmail,
    receiverFirstName,
    receiverId,
    receiverLastName,
    receiverMobile,
    scAddress,
    scTransactionId,
    scTransactionType,
    senderEmail,
    senderFirstName,
    senderId,
    senderLastName,
    senderMobile,
    totalAmount,
    transactionDate,
    transactionFees,
    transactionId,
    transactionMode,
    transactionStatus,
    unityStatus,
    transactionType,
    dateFrom,
    dateTo,
    holdingAccountType
  } = filter || {};

  if (amount) {
    url = url.concat(`&amount=${amount}`);
  }

  if (confirmationDate) {
    url = url.concat(`&confirmation_date=${confirmationDate}`);
  }

  if (confirmationId) {
    url = url.concat(`&confirmation_id=${confirmationId}`);
  }

  if (receiverEmail) {
    url = url.concat(`&receiverEmail=${receiverEmail}`);
  }

  if (receiverFirstName) {
    url = url.concat(`&receiverFirstName=${receiverFirstName}`);
  }

  if (receiverId) {
    url = url.concat(`&receiverId=${receiverId}`);
  }

  if (receiverLastName) {
    url = url.concat(`&receiverLastName=${receiverLastName}`);
  }

  if (receiverMobile) {
    url = url.concat(`&receiverCellNumber=${receiverMobile}`);
  }

  if (scAddress) {
    url = url.concat(`&scAddress=${scAddress}`);
  }

  if (scTransactionId) {
    url = url.concat(`&scTransactionId=${scTransactionId}`);
  }

  if (scTransactionType) {
    url = url.concat(`&scType=${scTransactionType}`);
  }

  if (senderEmail) {
    url = url.concat(`&senderEmail=${senderEmail}`);
  }

  if (senderFirstName) {
    url = url.concat(`&senderFirstName=${senderFirstName}`);
  }

  if (senderId) {
    url = url.concat(`&senderId=${senderId}`);
  }

  if (senderLastName) {
    url = url.concat(`&senderLastName=${senderLastName}`);
  }

  if (senderMobile) {
    url = url.concat(`&senderCellNumber=${senderMobile}`);
  }

  if (totalAmount) {
    url = url.concat(`&totalAmount=${totalAmount}`);
  }

  if (transactionDate) {
    url = url.concat(`&dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  if (transactionFees) {
    url = url.concat(`&fees=${transactionFees}`);
  }

  if (transactionId) {
    url = url.concat(`&transactionId=${transactionId}`);
  }

  if (transactionMode) {
    url = url.concat(`&transactionModeId=${transactionMode}`);
  }

  if (transactionStatus) {
    url = url.concat(`&transactionStatusId=${transactionStatus}`);
  }

  if (unityStatus) {
    url = url.concat(`&unityStatus=${unityStatus}`);
  }

  if (holdingAccountType) {
    url = url.concat(`&holdingAccountType=${holdingAccountType}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function clearingAccountReportExportUrl({ queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
  const skip = (pageNumber - 1) * pageSize;
  let url = `/reports/exportUnityTransactions?limit=${pageSize}&offset=${skip}`;

  const {
    amount,
    confirmationDate,
    confirmationId,
    receiverEmail,
    receiverFirstName,
    receiverId,
    receiverLastName,
    receiverMobile,
    scAddress,
    scTransactionId,
    scTransactionType,
    senderEmail,
    senderFirstName,
    senderId,
    senderLastName,
    senderMobile,
    totalAmount,
    transactionDate,
    transactionFees,
    transactionId,
    transactionMode,
    transactionStatus,
    unityStatus,
    transactionType,
    dateFrom,
    dateTo
  } = filter || {};

  if (amount) {
    url = url.concat(`&amount=${amount}`);
  }

  if (confirmationDate) {
    url = url.concat(`&confirmation_date=${confirmationDate}`);
  }

  if (confirmationId) {
    url = url.concat(`&confirmation_id=${confirmationId}`);
  }

  if (receiverEmail) {
    url = url.concat(`&receiverEmail=${receiverEmail}`);
  }

  if (receiverFirstName) {
    url = url.concat(`&receiverFirstName=${receiverFirstName}`);
  }

  if (receiverId) {
    url = url.concat(`&receiverId=${receiverId}`);
  }

  if (receiverLastName) {
    url = url.concat(`&receiverLastName=${receiverLastName}`);
  }

  if (receiverMobile) {
    url = url.concat(`&receiverCellNumber=${receiverMobile}`);
  }

  if (scAddress) {
    url = url.concat(`&scAddress=${scAddress}`);
  }

  if (scTransactionId) {
    url = url.concat(`&scTransactionId=${scTransactionId}`);
  }

  if (scTransactionType) {
    url = url.concat(`&scType=${scTransactionType}`);
  }

  if (senderEmail) {
    url = url.concat(`&senderEmail=${senderEmail}`);
  }

  if (senderFirstName) {
    url = url.concat(`&senderFirstName=${senderFirstName}`);
  }

  if (senderId) {
    url = url.concat(`&senderId=${senderId}`);
  }

  if (senderLastName) {
    url = url.concat(`&senderLastName=${senderLastName}`);
  }

  if (senderMobile) {
    url = url.concat(`&senderCellNumber=${senderMobile}`);
  }

  if (totalAmount) {
    url = url.concat(`&totalAmount=${totalAmount}`);
  }

  if (transactionDate) {
    url = url.concat(`&dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  if (transactionFees) {
    url = url.concat(`&fees=${transactionFees}`);
  }

  if (transactionId) {
    url = url.concat(`&transactionId=${transactionId}`);
  }

  if (transactionMode) {
    url = url.concat(`&transactionModeId=${transactionMode}`);
  }

  if (transactionStatus) {
    url = url.concat(`&transactionStatusId=${transactionStatus}`);
  }

  if (unityStatus) {
    url = url.concat(`&unityStatus=${unityStatus}`);
  }

  if (transactionType) {
    url = url.concat(`&transactionStatusId=${transactionType}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function clearingAccountChartDetailsUrl({ queryParamsChart }) {
  let url = `/reports/getUnityChart`;
  const { filter } = queryParamsChart || {};
  const { transactionDate, dateFrom, dateTo } = filter || {};
  if (transactionDate) {
    url = url.concat(`?dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  return url;
}

export function transactionsReportChartUrl({ queryParamsChart }) {
  let url = `/reports/getUnityLineChart`;
  const { filter } = queryParamsChart || {};
  const { transactionDate, dateFrom, dateTo } = filter || {};
  if (transactionDate) {
    url = url.concat(`?dateFilter=${transactionDate}`);
    if (transactionDate === "customrange") {
      if (dateFrom) {
        url = url.concat(`&range[0]=${dateFrom}`);
      }
      if (dateTo) {
        url = url.concat(`&range[1]=${dateTo}`);
      }
    }
  }

  return url;
}

export function transactionListExportUrl({ limit }) {
  var url = `/transactions/getTransactionHistory?limit=${limit}&offset=${0}`;
  return url;
}

export function userListUrl({ filterValues, queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  const {
    status,
    roleId,
    country,
    searchAccountNumber,
    searchFirstName,
    searchLastName,
    searchMobileNumber,
    searchEmail,
    searchBusinessName
  } = filterValues;
  let skip = (pageNumber - 1) * pageSize;

  var url = `/users/getUsersList?limit=${pageSize}&offset=${skip}`;

  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }

  if (roleId) {
    url = url.concat(`&roleId=${parseInt(roleId)}`);
  }

  if (country) {
    url = url.concat(`&country=${country}`);
  }

  if (searchAccountNumber) {
    url = url.concat(`&account_number=${searchAccountNumber}`);
  }

  if (searchFirstName) {
    url = url.concat(`&firstname=${searchFirstName}`);
  }

  if (searchLastName) {
    url = url.concat(`&lastname=${searchLastName}`);
  }

  if (searchMobileNumber) {
    url = url.concat(`&cellnumber=${searchMobileNumber}`);
  }

  if (searchEmail) {
    url = url.concat(`&email=${searchEmail}`);
  }

  if (searchBusinessName) {
    url = url.concat(`&business_name=${searchBusinessName}`);
  }

  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function userListExportUrl({ limit }) {
  var url = `/users/getUsersList?limit=${limit}&offset=0`;
  return url;
}

export const editStatusUserUrl = ({ id }) => {
  var url = `/users/activateOrDeactivateUser/${id}`;
  return url;
};

export function bankListUrl({ filterValues, queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  const { bank_name, status } = filterValues;
  logger("filterValues", filterValues);
  let skip = (pageNumber - 1) * pageSize;
  var url = `/banks/getBanksList?limit=${pageSize}&offset=${skip}`;
  if (bank_name) {
    url = url.concat(`&bank_name=${bank_name}`);
  }
  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function logoutUrl({ id }) {
  var url = `/accesstoken/Logout/${id}`;
  return url;
}

export function counterUrl() {
  var url = `/transactions/getTransactionCounters`;
  return url;
}

export function deleteBankUrl({ id }) {
  var url = `/banks/deleteBanks/${id}`;
  return url;
}

export function addBankUrl() {
  var url = "/banks/addBanks";
  return url;
}

export function editBankUrl({ id }) {
  var url = `/banks/editBanks/${id}`;
  return url;
}

export function deleteCityUrl({ id }) {
  var url = `/city/deleteCity/${id}`;
  return url;
}

export function addCityUrl() {
  var url = "/city/addCity";
  return url;
}

export function editCityUrl({ id }) {
  var url = `/city/editCity/${id}`;
  return url;
}

export function cityListUrl({ filterValues, queryParams, isActiveOnly }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  const { name, state_name, status } = filterValues;
  let skip = (pageNumber - 1) * pageSize;
  var url = `/city/getCityList?limit=${pageSize}&offset=${skip}&isActiveOnly=${isActiveOnly}`;
  if (name) {
    url = url.concat(`&name=${name}`);
  }
  if (state_name) {
    url = url.concat(`&state_name=${state_name}`);
  }
  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function addStateUrl() {
  var url = "/state/addState";
  return url;
}

export function editStateUrl({ id }) {
  var url = `/state/editState/${id}`;
  return url;
}

export function stateListUrl({ filterValues, queryParams, isActiveOnly }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  let skip = (pageNumber - 1) * pageSize;
  const { name, state_code, countryname, status } = filterValues;
  var url = `/state/getStateList?limit=${pageSize}&offset=${skip}&isActiveOnly=${isActiveOnly}`;
  if (name) {
    url = url.concat(`&state_name=${name}`);
  }
  if (state_code) {
    url = url.concat(`&state_code=${state_code}`);
  }
  if (countryname) {
    url = url.concat(`&country=${countryname}`);
  }
  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function stateListAllUrl({ isActiveOnly }) {
  var url = `/state/getStateList?limit=5000&offset=0&isActiveOnly=${isActiveOnly}`;
  return url;
}

export function deleteStateUrl({ id }) {
  var url = `/state/deleteState/${id}`;
  return url;
}

export function countryListUrl({ filterValues, queryParams, isActiveOnly }) {
  const { pageNumber, pageSize, sortOrder, sortField } = queryParams;
  const { searchName, searchCountryCode, status } = filterValues;
  let skip = (pageNumber - 1) * pageSize;
  var url = `/country/getCountryList?limit=${pageSize}&offset=${skip}&isActiveOnly=${isActiveOnly}`;
  if (searchName) {
    url = url.concat(`&search=${searchName}`);
  }
  if (searchCountryCode) {
    url = url.concat(`&country_code=${searchCountryCode}`);
  }
  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function countryListAllUrl({ isActiveOnly }) {
  var url = `/country/getCountryList?limit=500&offset=0&isActiveOnly=${isActiveOnly}`;
  return url;
}

export function addCountryUrl() {
  var url = "/country/addCountry";
  return url;
}

export function editCountryUrl({ id }) {
  var url = `/country/editCountry/${id}`;
  return url;
}

export function deleteCountryUrl({ id }) {
  var url = `/country/deleteCountry/${id}`;
  return url;
}

export function withdrawListUrl({ currentPage, filterValues, queryParams }) {
  const { pageSize, sortField, sortOrder } = queryParams;
  const {
    status,
    searchUserName,
    searchBankName,
    searchTransferAmount
  } = filterValues;
  let skip = (currentPage - 1) * pageSize;
  var url = `/transactions/getTransactionHistory?limit=${pageSize}&offset=${skip}&transactionTypeId=5`;

  if (status) {
    url = url.concat(`&status=${parseInt(status)}`);
  }
  if (searchUserName) {
    url = url.concat(`&sender_name=${searchUserName}`);
  }
  if (searchBankName) {
    url = url.concat(`&bank_name=${searchBankName}`);
  }
  if (searchTransferAmount) {
    url = url.concat(`&amount=${searchTransferAmount}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }

  return url;
}

export function recentTransactionListUrl(selectedTab) {
  var url = `/transactions/getRecentTransactions`;
  logger("selectedTab", selectedTab);

  // Recent Transacions by SC
  if (selectedTab && selectedTab === "second") {
    url = url.concat(`?is_sc=1`);
  }

  // Recent Accepted Payments
  if (selectedTab && selectedTab === "third") {
    url = url.concat(`?transactionStatusId=3`);
  }

  // Recent Rejected Payments
  if (selectedTab && selectedTab === "forth") {
    url = url.concat(`?transactionStatusId=2`);
  }

  // Recent Bank Transactions
  if (selectedTab && selectedTab === "fifth") {
    url = url.concat(`?transactionTypeId=5`);
  }
  return url;
}

export function dashboardFundCounterUrl() {
  var url = `/users/getDashboardFundCounters`;
  return url;
}

export function dashboardStatisticsCounterUrl() {
  var url = `/users/getDashboardStatisticsCounters`;
  return url;
}

export function reportAbuseListUrl({ filterValues, queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  const { searchName } = filterValues;
  let skip = (pageNumber - 1) * pageSize;
  var url = `/reportabuse/getReportAbuseList?limit=${pageSize}&offset=${skip}`;
  if (searchName) {
    url = url.concat(`&search=${searchName}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function accessLogListUrl({ filterValues, queryParams }) {
  const { pageNumber, pageSize, sortField, sortOrder } = queryParams;
  const { status, searchIP, searchUser } = filterValues;
  let skip = (pageNumber - 1) * pageSize;
  var url = `/accesslog/getAccessLogList?limit=${pageSize}&offset=${skip}`;
  if (status) {
    url = url.concat(`&method=${status}`);
  }
  if (searchIP) {
    url = url.concat(`&ip=${searchIP}`);
  }
  if (searchUser) {
    url = url.concat(`&user=${searchUser}`);
  }
  if (sortField && sortOrder) {
    url = url.concat(`&order=${sortField} ${sortOrder.toUpperCase()}`);
  }
  return url;
}

export function deleteReportAbuseUrl({ id }) {
  var url = `/reportabuse/deleteReportAbuse/${id}`;
  return url;
}

export function commissionListUrl({}) {
  var url = `/commissions/getCommissionList`;
  return url;
}

export function editCommissionUrl() {
  var url = `/commissions/editCommission`;
  return url;
}
